import React from 'react';

export const Cloudware: React.FC = () => {
	return (
		<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
			<rect width="40" height="40" fill="#E5E5E5" />
			<rect x="-59" y="-58" width="1426" height="229" fill="#ACD9ED" />
			<g filter="url(#filter0_d_2502_366381)">
				<rect x="-24" y="-24" width="844" height="174" rx="8" fill="white" />
				<rect width="40" height="40" rx="20" fill="white" />
				<path
					d="M28.712 10H11.2885C10.578 10 10 10.578 10 11.288V28.7115C10 29.422 10.578 30 11.2885 30H28.712C29.422 30 30 29.422 30 28.7115V11.2885C30 10.578 29.4225 10 28.712 10ZM28.439 28.4385H11.561V11.561H28.4385V28.4385H28.439Z"
					fill="#0D0D82"
				/>
				<path
					d="M17.5802 18.9801V20.1126L16.2397 20.1121C15.6187 20.1091 15.1102 19.6021 15.1072 18.9851L15.1067 15.9506C16.5057 16.2931 17.5782 17.5416 17.5802 18.9801ZM22.4192 19.0931C22.4217 17.5736 23.4772 16.2951 24.8927 15.9506L24.8922 18.9816C24.8887 19.6031 24.3807 20.1101 23.7622 20.1131L22.4187 20.1136V19.0931H22.4192ZM16.2367 21.6441H17.5807V23.0806C17.5807 24.0131 17.0652 24.1326 16.6167 24.1326H14.0017V25.6641H16.6167C18.1322 25.6641 19.1117 24.6501 19.1117 23.0806V21.6446H20.8872V25.6741H22.4187V21.6441H23.7657C25.2232 21.6381 26.4152 20.4476 26.4237 18.9856L26.4242 14.3271H25.6582C23.0317 14.3271 20.8917 16.4636 20.8872 19.0901L20.8867 20.1126H19.1112V18.9776C19.1067 16.4131 16.9667 14.3271 14.3402 14.3271H13.5742L13.5752 18.9901C13.5842 20.4471 14.7762 21.6381 16.2367 21.6441Z"
					fill="#0D0D82"
				/>
				<path
					fill-rule="evenodd"
					clip-rule="evenodd"
					d="M20 38.3333C30.1252 38.3333 38.3333 30.1252 38.3333 20C38.3333 9.87478 30.1252 1.66667 20 1.66667C9.87478 1.66667 1.66667 9.87478 1.66667 20C1.66667 30.1252 9.87478 38.3333 20 38.3333ZM20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
					fill="#EFF0F5"
				/>
				<rect x="-23.5" y="-23.5" width="843" height="173" rx="7.5" stroke="#EFF0F5" />
			</g>
			<defs>
				<filter
					id="filter0_d_2502_366381"
					x="-28"
					y="-26"
					width="852"
					height="182"
					filterUnits="userSpaceOnUse"
					color-interpolation-filters="sRGB"
				>
					<feFlood flood-opacity="0" result="BackgroundImageFix" />
					<feColorMatrix
						in="SourceAlpha"
						type="matrix"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
						result="hardAlpha"
					/>
					<feOffset dy="2" />
					<feGaussianBlur stdDeviation="2" />
					<feColorMatrix type="matrix" values="0 0 0 0 0.909804 0 0 0 0 0.929412 0 0 0 0 0.94902 0 0 0 1 0" />
					<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2502_366381" />
					<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2502_366381" result="shape" />
				</filter>
			</defs>
		</svg>
	);
};
